<template>
    <b-modal
        id="removeModal"
        ref="removeModal"
        size="sm"
        :title="title ? title : 'Löschen bestätigen'"
        ok-variant="danger"
        centered
        :busy="busy"
        @ok="ok"
        @hide="hide"
    >
        <slot>Datensatz wirklich löschen?</slot>
        <template slot="modal-ok">
            <template v-if="!busy">Löschen</template>
            <template v-else>
                <Spinner small variant="light" />
            </template>
        </template>
        <template slot="modal-cancel">Abbrechen</template>
    </b-modal>
</template>

<script>
import Spinner from "@/components/Spinner/Spinner";

export default {
    name: "RemoveModal",
    components: {
        Spinner
    },
    props: ["title", "busy"],
    methods: {
        ok(evt) {
            this.$emit("ok", evt);
        },
        hide(evt) {
            this.$emit("hide", evt);
        }
    }
};
</script>